
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";
import { TemplateCategory } from "@/data/templates";

interface SubcategoriesViewProps {
  category: TemplateCategory;
  onBack: () => void;
  onSelectSubcategory: (subcategoryId: string) => void;
}

const SubcategoriesView = ({ category, onBack, onSelectSubcategory }: SubcategoriesViewProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4 mb-6">
        <Button 
          variant="outline" 
          onClick={onBack}
          className="sidebar-button-no-hover gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar
        </Button>
        <div>
          <h2 className="text-2xl font-bold flex items-center gap-2 text-indigo-900">
            <span className="text-2xl">{category.emoji}</span>
            {category.name}
          </h2>
          <p className="text-purple-800 font-medium">
            {category.description}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-8 overflow-y-auto max-h-[calc(100vh-240px)] pr-2">
        {category.subcategories.map((subcategory) => (
          <Card 
            key={subcategory.id}
            className="document-template-card cursor-pointer"
            onClick={() => onSelectSubcategory(subcategory.id)}
          >
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2 text-indigo-900">
                <span className="text-xl">{subcategory.emoji}</span>
                {subcategory.name}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <Badge variant="outline" className="border-blue-200 text-blue-700">
                {subcategory.templates.length} modelos
              </Badge>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SubcategoriesView;
